export default __webpack_public_path__ + "static/media/icon-email-service-round.e610e5bd.svg";